import { gql } from "apollo-boost";
export const getListofMasterQuery = gql`
  query($offset: Int, $pageNo: Int, $descriptionName: String) {
    getListofMaster(
      NoOfRows: $offset
      offset: $pageNo
      descriptionName: $descriptionName
    ) {
      Id
      description
      allowmastersEntry
      allowforStatus
    }
  }
`;
export const getListofStatusQuery = gql`
  query($statusFor: String) {
    getListofStatus(statusFor: $statusFor) {
      Id
      statusId
      name
    }
  }
`;

export const getListofGenericMasterQuery = gql`
  query(
    $offset: Int
    $pageNo: Int
    $masterFor: Int!
    $descriptionName: String
  ) {
    getListofGenericMaster(
      NoOfRows: $offset
      offset: $pageNo
      masterFor: $masterFor
      descriptionName: $descriptionName
    ) {
      Id
      masterFor
      description
      status
      statusDetail {
        name
      }
    }
  }
`;
export const fetchGenericMasterQuery = gql`
  query(
    $offset: Int
    $pageNo: Int
    $masterFor: Int!
    $descriptionName: String
    $status: Int
  ) {
    getListofGenericMaster(
      NoOfRows: $offset
      offset: $pageNo
      masterFor: $masterFor
      descriptionName: $descriptionName
      status: $status
    ) {
      Id
      masterFor
      description
      status
    }
  }
`;

export const createGenericMastersQuery = gql`
  mutation CreateGenericMasters($masterFor: Int!, $description: String!) {
    createGenericMasters(
      data: { masterFor: $masterFor, description: $description }
    ) {
      genericMaster {
        Id
        description
      }
    }
  }
`;

export const getMasterByIdQuery = gql`
  query($id: Int) {
    getMasterById(id: $id) {
      Id
      description
      allowmastersEntry
      allowforStatus
    }
  }
`;

export const getGenericMasterByIdQuery = gql`
  query($id: Int) {
    getGenericMasterById(id: $id) {
      Id
      description
      masterFor
      status
      createdBy
      createdOn
      lastModifiedOn
      lastModifiedBy
      masterForDetail {
        Id
        description
      }
      statusDetail {
        Id
        name
      }
      lastModifiedDetail {
        Id
        loginId
      }
      createdDetail {
        Id
        loginId
      }
    }
  }
`;
export const fetchGenericMasterByIdQuery = gql`
  query($id: Int) {
    fetchGenericMasterById(id: $id)
  }
`;

export const UpdateGenericMastersQuery = gql`
  mutation UpdateGenericMasters(
    $Id: Int!
    $description: String!
    $status: Int!
  ) {
    updateGenericMasters(
      id: $Id
      data: { description: $description, status: $status }
    ) {
      message
    }
  }
`;

export const deleteGenericMastersQuery = gql`
  mutation DeleteGenericMasters($Id: Int!) {
    deleteGenericMasters(id: $Id) {
      message
    }
  }
`;